const getters = {
  isLogin: state => Reflect.has(state.userInfo, 'id'),
  products: state => {
    let data = state.userInfo;
    if (Object.keys(state.userInfo).length === 0) {
      data = JSON.parse(sessionStorage.getItem('userInfo'));
    }
    if (data.products && data.products.length > 0) {
      return data.products;
    }
    return [];
  },
  companyInfos: state => {
    let data = state.companyInfo;
    if (Object.keys(state.companyInfo).length === 0) {
      data = JSON.parse(sessionStorage.getItem('companyInfo'));
    }
    if (Object.keys(data).length > 0) {
      return data;
    }
    return {};
  },
  companyName: state => {
    let data = state.companyInfo;
    if (Object.keys(state.companyInfo).length === 0) {
      data = JSON.parse(sessionStorage.getItem('companyInfo'));
    }
    return data.company || '联韬';
  },
  companyLogo: state => {
    let data = state.companyInfo;
    if (Object.keys(state.companyInfo).length === 0) {
      data = JSON.parse(sessionStorage.getItem('companyInfo'));
    }
    return data.logo;
  }
};
export default getters;
